<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
        { type: 'alert', label: '알림 대상자 선택' },
      ]"
    />

    <!--    점검대상-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot" /> 점검대상</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-2 flex items-center" v-for="checkbox in form.inspectList" v-bind:key="checkbox.id">
        <div v-if="isPrint || board.readonly" class="flex">
          <div v-if="checkbox.check" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div v-else style="border: 1px solid #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          {{ checkbox.label }}
        </div>
        <label v-else class="flex">
          <vs-checkbox :readonly="board.readonly" v-model="checkbox.check" @change="checkForm"> </vs-checkbox>
          {{ checkbox.label }}
        </label>
      </div>
    </div>

    <!--    표-->
    <div v-for="(inspection, indexRows) in form.inspectList" v-bind:key="inspection.id">
      <table-inspect-ep
        class="mt-5"
        v-bind:key="inspection.id"
        :is-print="isPrint"
        :is-readonly="board.readonly"
        :is-show-title="true"
        :title="inspection.title"
        :list="inspection.list"
        :isNotDotInLabel="true"
        :is-check-type="inspection.isCheckType"
        table-header-title="착안사항"
        table-header-yes="양호"
        table-header-no="미흡"
        table-header-na="해당없음"
        :is-note="true"
        @update-list-check="
          (param1, param2) => {
            updateListCheck(indexRows, param1, param2);
          }
        "
        v-if="inspection.check"
      />
    </div>

    <!--    기타점검내용-->
    <table-etc-check
      title="기타점검내용"
      :list="form.etcList"
      table-header-title="착안사항"
      table-header-yes="양호"
      table-header-no="미흡"
      table-header-na="해당없음"
      @update-list-check="updateEtcListCheck"
      @updateList="updateList"
      @update-note="updateListNote"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
    />

    <!--    현장근로자 의견 청취 및 특이사항-->
    <div class="grid grid-cols-12 gap-x-6">
      <vs-row class="mt-8 col-span-12">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 현장근로자 의견 청취 및 특이사항</h5>
        </vs-col>
      </vs-row>
      <div class="col-span-4 flex items-center mt-4">
        <div class="label-text mr-4">현장근로자 의견 청취</div>
        <p v-if="isPrint" class="print-input">
          {{ form.inputC_1.fileName }}
        </p>
        <file-uploader v-else :readonly="board.readonly" v-model="form.inputC_1" class="flex-1 w-full" />
      </div>
      <div class="col-span-12 flex items-start mt-4">
        <div class="label-text mr-4 mt-2">특이사항</div>
        <span v-if="isPrint" class="print-textarea"> {{ form.inputC_2 }} </span>
        <ml-textarea v-else class="flex-1 w-full" rows="5" v-model="form.inputC_2" :readonly="board.readonly" />
      </div>
    </div>

    <!--    사진대지-->
    <PhotoUploadGridModule :row-count="2" :grid-count="2" v-model="form.photoList" :isPrint="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="신축현장 점검" />

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploader from "@/components/FileUploader.vue";
import TableInspectEp from "@/components/TableInspectCustomEp";
import TableEtcCheck from "@/components/TableEtcCheck";

export default {
  components: {
    TableEtcCheck,
    TableInspectEp,
    FileUploader,
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable;
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  methods: {
    checkForm() {
      this.form.typeTitleList = [];
      for (const data of this.form.inspectList) {
        if (data.check) {
          this.form.typeTitleList.push(data.label);
        }
      }
    },
    updateListCheck(indexList, indexTableRows, text) {
      this.form.inspectList[indexList].list[indexTableRows].is_checked = text;
    },

    updateEtcListCheck(row, text) {
      this.form.etcList[row].checked = text;
    },
    updateListNote(row, text) {
      this.form.etcList[row].note = text;
    },
    updateList(list) {
      this.form.etcList = list;
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        inputC_1: {},
        inputC_2: "",

        typeTitleList: [],
        inspectList: [],
        photoList: [],
        fileList: [],
        etcList: [],
      },
    };
  },
  computed: {
    inspectTable() {
      return [
        {
          id: 1,
          label: "정리정돈",
          check: false,
          title: "정리정돈",
          list: [
            {
              id: 1,
              label: "1. 작업장(현장) 정리정돈 상태는?",
              is_checked: "",
              note: "",
            },
            {
              id: 2,
              label: "2. 공구 및 기계의 정비 및 정리정돈 상태는?",
              is_checked: "",
              note: "",
            },
          ],
        },
        {
          id: 2,
          label: "화재방지",
          check: false,
          title: "화재방지",
          list: [
            {
              id: 1,
              label: "1. 작업현장 근처에 가연성물질,인화성물질이 있는가?",
              is_checked: "",
              note: "",
            },
            {
              id: 2,
              label: "2. 작업 전 가스, 분진 및 환기상태 여부 확인하는가?",
              is_checked: "",
              note: "",
            },
          ],
        },
        {
          id: 3,
          label: "추락재해방지",
          check: false,
          title: "추락재해방지",
          list: [
            {
              id: 1,
              label: "1. 추락위험이 있는 장소에 작업발판이 설치되어 있는가?",
              is_checked: "",
              note: "",
            },
            {
              id: 2,
              label: "2. 바닥면에서 높이 1m이상인 계단의 개방된 측면에 안전난간이 설치되어 있는가?",
              is_checked: "",
              note: "",
            },
            {
              id: 3,
              label: "3. 기계기구 또는 설비에 설치한 방호장치를 임의해체하거나 기능을 해제한 상태로 사용하는가?",
              is_checked: "",
              note: "",
            },
            {
              id: 4,
              label: "4. 끼임 위험이 있는 원동기, 회전축, 기어 및 체인에 대한 방호장치의 유무 및 유지관리 여부",
              is_checked: "",
              note: "",
            },
            {
              id: 5,
              label: "5. 동력으로 작동되는 기계에 스위치, 클러치, 벨트이동장치 등 동력차단장치 설치 유무",
              is_checked: "",
              note: "",
            },
            {
              id: 6,
              label: "6. 수리, 점검, 청소, 세척 작업시 전원은 차단하고 작업하는가?",
              is_checked: "",
              note: "",
            },
            {
              id: 7,
              label: "7. 위험기계 작업전 안전교육 실시 여부",
              is_checked: "",
              note: "",
            },
          ],
        },
        {
          id: 4,
          label: "끼임재해방지",
          check: false,
          title: "끼임재해방지",
          list: [
            {
              id: 1,
              label: "1. 위험기계기구에 적합한 방호장치를 설치하고 있으며, 안전인증·안전검사 대상인 경우 인증 또는 검사를 받고 사용하고 있는가?",
              is_checked: "",
              note: "",
            },
            {
              id: 2,
              label: "2. 위험기계기구의 방호조치 등의 기능이 유지되고 있는가?",
              is_checked: "",
              note: "",
            },
            {
              id: 3,
              label: "3. 기계기구 또는 설비에 설치한 방호장치를 임의해체하거나 기능을 해제한 상태로 사용하는가?",
              is_checked: "",
              note: "",
            },
            {
              id: 4,
              label: "4. 끼임 위험이 있는 원동기, 회전축, 기어 및 체인에 대한 방호장치의 유무 및 유지관리 여부",
              is_checked: "",
              note: "",
            },
            {
              id: 5,
              label: "5. 동력으로 작동되는 기계에 스위치, 클러치, 벨트이동장치 등 동력차단장치 설치 유무",
              is_checked: "",
              note: "",
            },
            {
              id: 6,
              label: "6. 수리, 점검, 청소, 세척 작업시 전원은 차단하고 작업하는가?",
              is_checked: "",
              note: "",
            },
            {
              id: 7,
              label: "7. 위험기계 작업전 안전교육 실시 여부",
              is_checked: "",
              note: "",
            },
          ],
        },
        {
          id: 5,
          label: "넘어짐·베임방지",
          check: false,
          title: "넘어짐·베임방지",
          list: [
            {
              id: 1,
              label: "1. 이동시 바닥의 상태, 턱, 장애물 유무 확인하는가?",
              is_checked: "",
              note: "",
            },
            {
              id: 2,
              label: "2. 물건이동시 날카로움, 베일 우려가 있는지 확인하는가?",
              is_checked: "",
              note: "",
            },
            {
              id: 3,
              label: "3. 계단끝단 미끄럼방지조치, 계단난간 설치 및 이동통로에 적정 조도는 확보되었는가?",
              is_checked: "",
              note: "",
            },
          ],
        },
        {
          id: 6,
          label: "보호구",
          check: false,
          title: "보호구",
          list: [
            {
              id: 1,
              label: "1. 적절한 보호구는 지급하고 있는가?",
              is_checked: "",
              note: "",
            },
            {
              id: 2,
              label: "2. 적절한 보호구는 착용하고 있는가?",
              is_checked: "",
              note: "",
            },
            {
              id: 3,
              label: "3. 보호구는 주기적인 점검 및 교체 여부",
              is_checked: "",
              note: "",
            },
            {
              id: 4,
              label: "4. 보호구 지급대장 작성하고 있는가?",
              is_checked: "",
              note: "",
            },
          ],
        },
        {
          id: 7,
          label: "안전점검 및 검사",
          check: false,
          title: "안전점검 및 검사",
          isCheckType: true,
          list: [
            {
              id: 1,
              title: "위험기계·기구설비 안전검사",
              is_checked: "",
              note: "최초 설치 후 3년 이내 1회, 이후 2년 1회",
              checkList: [
                {
                  label: "리프트",
                  check: false,
                },
                {
                  label: "크레인",
                  check: false,
                },
                {
                  label: "곤도라",
                  check: false,
                },
                {
                  label: "전단기",
                  check: false,
                },
                {
                  label: "압력용기",
                  check: false,
                },
                {
                  label: "프레스",
                  check: false,
                },
                {
                  label: "로울러기",
                  check: false,
                },
                {
                  label: "사출성형기",
                  check: false,
                },
                {
                  label: "국소배기장치",
                  check: false,
                },
                {
                  label: "컨베이어",
                  check: false,
                },
                {
                  label: "원심기",
                  check: false,
                },
                {
                  label: "산업용 로봇",
                  check: false,
                },
                {
                  label: "고소작업대",
                  check: false,
                },
              ],
            },
          ],
        },
        {
          id: 8,
          label: "방호장치가 필요한 기계·기구",
          check: false,
          title: "방호장치가 필요한 기계·기구",
          isCheckType: true,
          list: [
            {
              id: 1,
              is_checked: "",
              note: "동력으로 작동하는 기계·기구",
              checkList: [
                {
                  label: "예초기",
                  check: false,
                },
                {
                  label: "원심기",
                  check: false,
                },
                {
                  label: "공기압축기",
                  check: false,
                },
                {
                  label: "금속절단기",
                  check: false,
                },
                {
                  label: "지게차",
                  check: false,
                },
                {
                  label: "진공포장기",
                  check: false,
                },
                {
                  label: "랩핑기",
                  check: false,
                },
              ],
            },
          ],
        },
        {
          id: 9,
          label: "전기기계기구",
          check: false,
          title: "전기기계기구",
          list: [
            {
              id: 1,
              label: "1. 전기기계기구 사용 중 누전에 의한 감전사고 발생의 위험은 없는가?",
              is_checked: "",
              note: "",
            },
            {
              id: 2,
              label: "2. 물기가 많은 습윤한 장소, 바닥에서 전기기계기구 사용 중 감전사고 발생의 위험은 없는가?",
              is_checked: "",
              note: "",
            },
            {
              id: 3,
              label: "3. 전기기계기구의 전선피복 절연상태는 양호한가?",
              is_checked: "",
              note: "",
            },
            {
              id: 4,
              label: "4. 전선의 피복 손상은 있는가?",
              is_checked: "",
              note: "",
            },
          ],
        },
        {
          id: 10,
          label: "이동식 사다리",
          check: false,
          title: "이동식 사다리",
          list: [
            {
              id: 1,
              label: "1. 사다리는 평탄·견고하고 미끄럼이 없는 바닥에서 사용하는가?",
              is_checked: "",
              note: "",
            },
            {
              id: 2,
              label: "2. 작업높이 3.5m이하로 작업하고 있는가?",
              is_checked: "",
              note: "",
            },
            {
              id: 3,
              label: "3. 안전모 착용하고 작업하는가?",
              is_checked: "",
              note: "",
            },
            {
              id: 4,
              label: "4. 1.2m이상 작업시 2인1조 작업하고 있는가?",
              is_checked: "",
              note: "",
            },
            {
              id: 5,
              label: "5. 최상부 발판에서 작업금지하고 있는가?",
              is_checked: "",
              note: "",
            },
            {
              id: 6,
              label: "6. 작업높이 2m이상인 경우 안전대 착용하고 있는가?",
              is_checked: "",
              note: "",
            },
          ],
        },
        {
          id: 11,
          label: "도로보수",
          check: false,
          title: "도로 보수 작업",
          list: [
            {
              id: 1,
              label: "1. 작업지휘자(유도자) 배치",
              is_checked: "",
              note: "",
            },
            {
              id: 2,
              label: "2. 작업중 입간판(안내판) 설치",
              is_checked: "",
              note: "",
            },
            {
              id: 3,
              label: "3. 차량 위험·경고등 작동",
              is_checked: "",
              note: "",
            },
            {
              id: 4,
              label: "4. 신호수 배치",
              is_checked: "",
              note: "",
            },
            {
              id: 5,
              label: "5. 반사안전조끼 착용",
              is_checked: "",
              note: "",
            },
            {
              id: 6,
              label: "6. 15kg 이상은 2인1조 작업",
              is_checked: "",
              note: "",
            },
            {
              id: 7,
              label: "7. 작업시간 조정",
              is_checked: "",
              note: "",
            },
            {
              id: 8,
              label: "8. 충분한 음료섭취 및 휴식",
              is_checked: "",
              note: "",
            },
          ],
        },
        {
          id: 12,
          label: "청소차량",
          check: false,
          title: "청소차량 작업",
          list: [
            {
              id: 1,
              label: "1. 보호구 지급 및 활용",
              is_checked: "",
              note: "",
            },
            {
              id: 2,
              label: "2. 경광등 정상작동 여부",
              is_checked: "",
              note: "",
            },
            {
              id: 3,
              label: "3. 후방영상장치 정상작동 여부",
              is_checked: "",
              note: "",
            },
            {
              id: 4,
              label: "4. 양수조작 스위치 정상작동 여부",
              is_checked: "",
              note: "",
            },
            {
              id: 5,
              label: "5. 차량 등화류 정상작동 여부",
              is_checked: "",
              note: "",
            },
            {
              id: 6,
              label: "6. 유압장치 작동유 유량 적정 여부",
              is_checked: "",
              note: "",
            },
            {
              id: 7,
              label: "7. 차량 엔진오일, 타이어 공기압 적정 여부",
              is_checked: "",
              note: "",
            },
            {
              id: 8,
              label: "8. 차량 전면 유리창, 후방조사경 청결 여부",
              is_checked: "",
              note: "",
            },
          ],
        },
        {
          id: 13,
          label: "청소차량 및 환경미화원",
          check: false,
          title: "청소차량 및 환경미화원 작업",
          list: [
            {
              id: 1,
              label: "1. 사무실 콘센트, 소화기 및 냉난방 상태 등",
              is_checked: "",
              note: "",
            },
            {
              id: 2,
              label: "2. 차고지 출구 운전 상태, 주의운전 여부 및 고임목 설치 여부 등",
              is_checked: "",
              note: "",
            },
            {
              id: 3,
              label: "3. 샤워장 미끄럼 방지 및 청결유지 상태",
              is_checked: "",
              note: "",
            },
            {
              id: 4,
              label: "4. 안전보건교육 실시",
              is_checked: "",
              note: "",
            },
            {
              id: 5,
              label: "5. 건강검진(채용전 포함)에 관한 사항",
              is_checked: "",
              note: "",
            },
            {
              id: 6,
              label: "6. 수거에 관한 사항",
              is_checked: "",
              note: "",
              title: "종량제봉투 수집 운반",
            },
            {
              id: 7,
              label: "7. 상차 적재에 관한 사항",
              is_checked: "",
              note: "",
              title: "종량제봉투 수집 운반",
            },
            {
              id: 8,
              label: "8. 청소차 이동에 관한 사항",
              is_checked: "",
              note: "",
              title: "종량제봉투 수집 운반",
            },
            {
              id: 9,
              label: "9. 자원회수시설에 관한 사항",
              is_checked: "",
              note: "",
              title: "종량제봉투 수집 운반",
            },
            {
              id: 10,
              label: "10. 배출장소 이동 및 수거에 관한 사항",
              is_checked: "",
              note: "",
              title: "음식물쓰레기 수집 운반",
            },
            {
              id: 11,
              label: "11. 음식물쓰레기 등 상차 및 이적에 관한 사항",
              is_checked: "",
              note: "",
              title: "음식물쓰레기 수집 운반",
            },
            {
              id: 12,
              label: "12. 수거차량 이동에 관한 사항",
              is_checked: "",
              note: "",
              title: "음식물쓰레기 수집 운반",
            },
            {
              id: 13,
              label: "13. 배출장소 이동 및 수거에 관한 사항",
              is_checked: "",
              note: "",
              title: "재활용품 수집 운반",
            },
            {
              id: 14,
              label: "14. 재활용품 등 상차 및 이적에 관한 사항",
              is_checked: "",
              note: "",
              title: "재활용품 수집 운반",
            },
            {
              id: 15,
              label: "15. 수거차량 이동에 관한 사항",
              is_checked: "",
              note: "",
              title: "재활용품 수집 운반",
            },
          ],
        },
      ];
    },
  },
};
</script>

<style scoped lang="scss">
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
</style>
